"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Expertise() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const values = [{
    label: "Concierge Privacy",
    description: "Your aesthetic journey is private, discreet, and tailored to your schedule."
  }, {
    label: "Facial Balancing",
    description: "We focus on symmetry and proportion to enhance your unique features."
  }, {
    label: "Preventative Care",
    description: "Using fillers early to soften lines and maintain youthful skin integrity."
  }, {
    label: "Natural Results",
    description: "Refined, effortless enhancements that look like you, only refreshed."
  }];
  return <section data-section-id="19019" id="expertise-you-can-trust" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto max-w-7xl px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={imageRef} className="lg:col-span-5 transition-all duration-[500ms] ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0) translateZ(0)" : "translateY(16px) translateZ(0)"
        }}>
            <div className="overflow-hidden rounded-3xl aspect-square lg:aspect-[4/5] group shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_consultation_room.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_consultation_room.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_consultation_room.webp-wvc-sizes" alt="Dr. Amber Ojeda providing a personalized aesthetic consultation" loading="lazy" decoding="async" fetchPriority="high" className="w-full h-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
            </div>
          </div>

          {}
          <div ref={copyRef} className="lg:col-span-7 lg:mt-8 transition-all duration-[500ms] ease-out" style={{
          opacity: copyVisible ? 1 : 0,
          transform: copyVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: copyVisible ? "80ms" : "0ms"
        }}>
            <p className="font-default text-[0.75rem] font-bold uppercase tracking-[0.2em] text-primary leading-none mb-6">
              Our Philosophy
            </p>

            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2.125rem, 3.8vw, 3.375rem)",
            fontWeight: 500,
            letterSpacing: "-0.01em",
            lineHeight: 1.2
          }}>
              Refined facial balancing, delivered with{" "}
              <span className="italic text-primary inline-block transition-all duration-[520ms] ease-out" style={{
              opacity: copyVisible ? 1 : 0,
              transform: copyVisible ? "translateY(0)" : "translateY(4px)",
              transitionDelay: copyVisible ? "280ms" : "0ms"
            }}>
                precision
              </span>
            </h2>

            <p className="font-default text-foreground mt-6" style={{
            fontSize: "clamp(1.125rem, 1.25vw, 1.3125rem)",
            lineHeight: 1.7,
            color: "var(--muted-foreground)"
          }}>At Ideal Image Aesthetics and Wellness, LLC&nbsp; we believe in the art of subtle transformation. Dr. Ojeda, FNP combines clinical expertise with a concierge approach to provide facial balancing that restores symmetry and supports your natural, effortless beauty.</p>

            {}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
              {values.map((value, i) => <div data-index={i} key={i}>
                  <h4 className="font-default text-foreground" style={{
                fontWeight: 500,
                fontSize: "1.0625rem",
                letterSpacing: "0.005em",
                lineHeight: 1.35
              }}>
                    {value.label}
                  </h4>
                  <p className="font-default text-muted-foreground mt-2" style={{
                fontSize: "0.9375rem",
                lineHeight: 1.5
              }}>
                    {value.description}
                  </p>
                </div>)}
            </div>

            {}
            <div className="mt-12">
              <Link to="/ExperiencePage" className="inline-block font-default text-foreground hover:text-primary transition-all duration-300" style={{
              textDecoration: "underline",
              textDecorationColor: "var(--primary)",
              textDecorationThickness: "1.5px",
              textUnderlineOffset: "6px"
            }}>
                Discover our approach
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}